import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=57bbee7c&scoped=true&"
import script from "./HeaderPage.vue?vue&type=script&lang=ts&"
export * from "./HeaderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bbee7c",
  null
  
)

export default component.exports